"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var shallowEqual = require('shallowequal');

function useCollector(monitor, collect) {
  var _a = react_1.useState(function () {
    return collect(monitor);
  }),
      collected = _a[0],
      setCollected = _a[1];

  var updateCollected = function updateCollected() {
    var nextValue = collect(monitor);

    if (!shallowEqual(collected, nextValue)) {
      setCollected(nextValue);
    }
  };

  return [collected, updateCollected];
}

exports.useCollector = useCollector;